import { render, staticRenderFns } from "./AddBankAdmin.vue?vue&type=template&id=66d57456&scoped=true&"
import script from "./AddBankAdmin.vue?vue&type=script&lang=js&"
export * from "./AddBankAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d57456",
  null
  
)

export default component.exports